/**
 * Symbol/Character for BURST unit
 * @module util
 * */
export const BurstSymbol = 'Ƀ';

/**
 * Symbol/Character for Planck (the smallest possible unit in Burstcoin)
 * @module util
 * */
export const BurstPlanckSymbol = 'ƀ';

/**
 * The smallest possible fee
 * @module util
 */
export const FeeQuantPlanck = 735000;

/**
 * One Burst expressed in Planck
 * @module util
 */
export const OneBurstPlanck = 100000000;
